/**
 *  author: Patrick Vyn Badiang
 *
 *  Description:
 *  is the paragraph about FASA
 */

import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";

import React, { useEffect, useState } from 'react';

import EyebrowLabel from "./EyebrowLabel";

const fasaMembers = "/pictures/DSCF6278.JPG";


function SummaryOfFasa() {

    const [summaryFile, setSummaryFile] = useState('');



  useEffect(() => {
    fetch('/textfiles/Summary.txt')
      .then(response => response.text())
      .then(content => setSummaryFile(content))
      .catch(error => console.log(error));
  }, []);

    return (
        <Box sx={{ bgcolor: "background.default", py: { xs: "48px", md: "90px" }, px: { xs: "20px", md: "48px" } }}>
            <Grid container spacing={{ xs: 4, md: 7 }} alignItems="center" sx={{ maxWidth: "1200px", mx: "auto" }}>
                <Grid xs={12} md={5}>
                    <Box
                        component="img"
                        src={fasaMembers}
                        alt="FASA members"
                        sx={{
                            width: "100%",
                            aspectRatio: "4 / 3",
                            objectFit: "cover",
                            borderRadius: "4px",
                            boxShadow: "14px 14px 0 #f2c94c",
                        }}
                    />
                </Grid>
                <Grid xs={12} md={7}>
                    <EyebrowLabel color="secondary.main" sx={{ fontSize: { xs: "1.15rem", md: "1.3rem" } }}>Our Story</EyebrowLabel>
                    <Typography variant="h2" sx={{ mt: "12px", mb: "20px" }}>
                        What is FASA?
                    </Typography>
                    <Typography variant="body1" sx={{ maxWidth: "560px", fontSize: { xs: "1.1rem", md: "1.15rem" }, lineHeight: 1.6 }}>
                        {summaryFile}
                    </Typography>
                </Grid>
            </Grid>
        </Box>

    )

}

export default SummaryOfFasa;
